import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_LAND_USE_POPULATION',
  name: 'Workspace Project Land Use Population',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'informationBasis', title: 'Description' },
    { key: 'people', title: 'Total Size' },
    { key: 'families', title: 'Carbon credits total size' },
    { key: 'district', title: 'Districts' },
    { key: 'village', title: 'Villages' },
    { key: 'description', title: 'Description' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPLOAD', 'DESTROY'],
}

export default scope
